document.documentElement.classList.remove('no-js');

(() => {
  const panel = document.querySelector('[data-header-search]');
  if (!panel) return;
  const toggle = document.querySelector('[data-search-toggle]');
  const closeButton = panel.querySelector('[data-search-close]');
  const clearButton = panel.querySelector('[data-search-clear]');
  const form = panel.querySelector('[data-predictive-search-form]');
  const input = panel.querySelector('[data-predictive-search-input]');
  const results = panel.querySelector('[data-predictive-search-results]');
  const status = panel.querySelector('[data-search-status]');
  let timer;
  let request;

  const setOpen = (open) => {
    panel.hidden = !open;
    toggle?.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('search-is-open', open);
    if (open) window.requestAnimationFrame(() => input.focus());
  };
  const clearResults = (message = 'Aramak için en az 2 karakter yazın.') => {
    results.replaceChildren();
    status.textContent = message;
  };
  const money = (value) => {
    const amount = Number.parseFloat(value);
    if (!Number.isFinite(amount)) return '';
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: window.Shopify?.currency?.active || 'TRY' }).format(amount);
  };
  const createResult = (item, type) => {
    const link = document.createElement('a');
    link.className = 'predictive-result';
    link.href = item.url;
    link.setAttribute('role', 'option');
    const media = document.createElement('span');
    media.className = 'predictive-result__media';
    const imageSource = item.featured_image?.url || item.image?.url;
    if (imageSource) {
      const image = document.createElement('img');
      image.src = imageSource + (imageSource.includes('?') ? '&' : '?') + 'width=140';
      image.alt = '';
      image.width = 70;
      image.height = 70;
      image.loading = 'lazy';
      media.append(image);
    }
    const content = document.createElement('span');
    content.className = 'predictive-result__content';
    const label = document.createElement('span');
    label.className = 'predictive-result__type';
    label.textContent = type === 'product' ? 'Ürün' : 'Koleksiyon';
    const title = document.createElement('span');
    title.className = 'predictive-result__title';
    title.textContent = item.title;
    content.append(label, title);
    link.append(media, content);
    if (type === 'product') {
      const price = document.createElement('span');
      price.className = 'predictive-result__price';
      price.textContent = money(item.price);
      link.append(price);
    }
    return link;
  };
  const search = async () => {
    const query = input.value.trim();
    clearButton.hidden = query.length === 0;
    if (query.length < 2) {
      request?.abort();
      clearResults();
      return;
    }
    request?.abort();
    request = new AbortController();
    status.textContent = 'Aranıyor…';
    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,collection',
      'resources[limit]': '8',
      'resources[options][unavailable_products]': 'last'
    });
    try {
      const response = await fetch('/search/suggest.json?' + params.toString(), {
        signal: request.signal,
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Arama isteği başarısız');
      const data = await response.json();
      const products = data.resources?.results?.products || [];
      const collections = data.resources?.results?.collections || [];
      results.replaceChildren(
        ...products.map((item) => createResult(item, 'product')),
        ...collections.map((item) => createResult(item, 'collection'))
      );
      const count = products.length + collections.length;
      status.textContent = count ? count + ' sonuç bulundu.' : 'Eşleşen ürün veya koleksiyon bulunamadı.';
      if (!count) {
        const empty = document.createElement('p');
        empty.className = 'header-search__empty';
        empty.textContent = 'Farklı bir ürün adı, taş veya koleksiyon deneyin.';
        results.append(empty);
      }
    } catch (error) {
      if (error.name !== 'AbortError') clearResults('Arama şu anda kullanılamıyor. Lütfen tekrar deneyin.');
    }
  };
  toggle?.addEventListener('click', () => setOpen(panel.hidden));
  closeButton?.addEventListener('click', () => setOpen(false));
  clearButton?.addEventListener('click', () => {
    input.value = '';
    clearButton.hidden = true;
    clearResults();
    input.focus();
  });
  input.addEventListener('input', () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(search, 220);
  });
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    window.clearTimeout(timer);
    search();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) setOpen(false);
  });
  document.addEventListener('click', (event) => {
    if (!panel.hidden && !panel.contains(event.target) && !toggle?.contains(event.target)) setOpen(false);
  });
})();

class RoseGumusSlider extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.index = 0;
    this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1));
    this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1));
    this.querySelectorAll('[data-dot]').forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));
    if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.speed || 6000));
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
    }
    this.show(0);
  }
  show(index) {
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.setAttribute('aria-hidden', i !== this.index); });
    this.querySelectorAll('[data-dot]').forEach((dot, i) => dot.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
  }
}
customElements.define('rosegumus-slider', RoseGumusSlider);

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-menu-toggle]');
  if (trigger) {
    const menu = document.querySelector('#MobileMenu');
    const open = menu.toggleAttribute('data-open');
    trigger.setAttribute('aria-expanded', open);
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const form = select.closest('form');
  const button = form?.querySelector('[type="submit"]');
  if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = option.dataset.available === 'true' ? 'Sepete Ekle' : 'Tükendi'; }
  history.replaceState({}, '', `${location.pathname}?variant=${select.value}`);
});
